/* eslint-disable curly */
import {
  getCombinationInfo,
  getListProductsInfo,
  getSKU,
  generateCombinationName,
} from '../helpers/product.js';
import ENV from '../env.js';
import FbConversion from './fb-conversion';
import { formatAttributeSlug } from '~global/helpers.js';
const $get = require('lodash.get');
const Config = require('~config/default.env').default;
const GoogleTagManager = {
  payload: {},
  eventName: '',
  addPaymentInfo(dataPaymentInfo) {
    const extractProducts = getListProductsInfo(dataPaymentInfo.carts.products);
    const contentsId = extractProducts.contentsId.every((Id) => Id === '')
      ? ''
      : extractProducts.contentsId.join(', ');
    this.payload = {
      event: 'addPaymentInfo',
      add_payment_info_data: {
        Payment_Type: dataPaymentInfo.payment_type,
        Id_Payment_Method: dataPaymentInfo.id_payment_method,
        Price: dataPaymentInfo.total_price,
        Content_Category: dataPaymentInfo.payment_type,
        Product_Name: extractProducts.productsName,
        Quantity: extractProducts.totalQuantity,
        Brands: extractProducts.brands,
        Amount_Of_Purchase: dataPaymentInfo.total_price,
        Category_Parent: extractProducts.categoriesParent,
        Category_Child: extractProducts.categoriesChild,
        Category_GrandChild: extractProducts.categoriesGrandChild,
        Category: extractProducts.categoriesParent,
        Contents: extractProducts.contents,
        Content_Ids: extractProducts.contentsId,
      },
    };
    window.dataLayer.push(this.payload);
    FbConversion.fbTracking({
      name: 'AddPaymentInfo',
      data: {
        content_category: extractProducts.categoriesParent.join(', '),
        content_subcategory1: extractProducts.categoriesChild.join(', '),
        content_ids: contentsId,
        contents: extractProducts.contents,
        content_name: extractProducts.productsName.join(', '),
        currency: 'IDR',
        value: parseFloat(dataPaymentInfo.total_price),
        content_type: 'product',
      },
    });
    this.eventName = 'addPaymentInfo';
    return this;
  },
  addToCart(product, qty) {
    const combinationInfo = getCombinationInfo(product);
    let contentId = $get(
      product,
      'default_combination.tracker_combination_name',
      '',
    );

    if (!contentId) {
      const productId = product.id;
      const attributeSlug =
        formatAttributeSlug(combinationInfo.attributeSlug) || '';
      contentId = `${productId}_${attributeSlug}`;
    }

    let price;
    if (product?.default_combination?.price_after_discount) {
      price = $get(product, 'default_combination.price_after_discount', 0);
    } else if (product?.combination?.price_after_discount) {
      price = $get(product, 'combination.price_after_discount', 0);
    } else {
      price = 0;
    }

    this.payload = {
      event: 'addToCart',
      cart_data: {
        Brand: $get(product, 'brand.name', ''),
        Category_Parent: $get(product, 'categories[0].name', ''),
        Category_Child: $get(product, 'categories[1].name', ''),
        Category_GrandChild: $get(product, 'categories[2].name', ''),
        Category: $get(product, 'default_category.name', ''),
        Id: product.id,
        Product_Name: product.name,
        Price: price,
        Combination_Name: combinationInfo.combinationName,
        Attribute_Slug: combinationInfo.attributeSlug,
        Quantity: qty,
        Content_Ids: contentId.toLowerCase(),
        Contents: [{ id: contentId.toLowerCase(), quantity: qty }],
        SKU: getSKU(product),
      },
      ga4Cart: {
        items: [
          {
            item_id: product.id,
            item_name: product.name,
            quantity: parseInt(qty),
            price: price,
            item_brand: $get(product, 'brand.name', ''),
            item_category: $get(product, 'default_category.name', ''),
            item_category2: $get(product, 'categories[0].name', ''),
            item_category3: $get(product, 'categories[1].name', ''),
            item_category4: $get(product, 'categories[1].name', ''),
            item_variant: combinationInfo.combinationName,
          },
        ],
      },
    };

    window.dataLayer.push(this.payload);
    FbConversion.fbTracking({
      name: 'AddToCart',
      data: {
        value: parseFloat(price),
        content_name: product.name,
        currency: 'IDR',
        content_ids: contentId.toLowerCase(),
        content_type: 'product',
        content_category: $get(product, 'categories[0].name', ''),
        content_subcategory1: $get(product, 'categories[1].name', ''),
        // content_subcategory2: $get(product, 'categories[2].name', ''),
        // sku: getSKU(product),
        brand: $get(product, 'brand.name', ''),
        contents: [{ id: contentId.toLowerCase(), quantity: qty }],
        // combination_name: combinationInfo.combinationName,
        product_id: product.id,
      },
    });

    try {
      this.trackCartInsiderAddToCart(
        product,
        product.combination || product.default_combination,
        qty,
      );
    } catch (e) {
      console.error('Error tracking Insider Add To Cart:', e);
    }

    this.eventName = 'addToCart';
    return this;
  },
  addToWishlist(product) {
    const combinationInfo = getCombinationInfo(product);
    let contentId = $get(
      product,
      'default_combination.tracker_combination_name',
      '',
    );

    if (!contentId) {
      const productId = product.id;
      const attributeSlug =
        formatAttributeSlug(combinationInfo.attributeSlug) || '';
      contentId = `${productId}_${attributeSlug}`;
    }

    this.payload = {
      event: 'addToWishlist',
      wishlist_data: {
        Brand: $get(product, 'brand.name', ''),
        Category_Parent: $get(product, 'categories[0].name', ''),
        Category_Child: $get(product, 'categories[1].name', ''),
        Category_GrandChild: $get(product, 'categories[2].name', ''),
        Id: product.id,
        Product_Name: product.name,
        Price: $get(product, 'default_combination.price_after_discount', ''),
        Combination_Name: combinationInfo.combinationName,
        Content_Ids: contentId.toLowerCase(),
        Contents: [
          {
            id: contentId.toLowerCase(),
            quantity: 1,
          },
        ],
        Quantity: 1,
      },
    };
    window.dataLayer.push(this.payload);
    FbConversion.fbTracking({
      name: 'AddToWishlist',
      data: {
        content_ids: contentId.toLowerCase(),
        content_type: 'product',
        content_name: product.name,
        content_category: $get(product, 'default_category.name', ''),
        content_subcategory1: $get(product, 'categories[0].name', ''),
        content_subcategory2: $get(product, 'categories[1].name', ''),
        value: $get(product, 'default_combination.price_after_discount', ''),
        currency: 'IDR',
        brand: $get(product, 'brand.name', ''),
        quantity: 1,
        contents: [
          {
            id: contentId.toLowerCase(),
            quantity: 1,
          },
        ],
      },
    });
    this.eventName = 'addToWishlist';
    return this;
  },
  initiateCheckout(data) {
    const extractProducts = getListProductsInfo(data.products);
    const price =
      'total_amount_after_discount' in data
        ? data.total_amount_after_discount
        : 0;

    const contentsId = extractProducts.contentsId.every((Id) => Id === '')
      ? ''
      : extractProducts.contentsId.join(', ');
    this.payload = {
      event: 'initiateCheckout',
      initiate_checkout_data: {
        Content_Ids: extractProducts.contentsId,
        Cart_Id: data.cart_id,
        Shipping_Type: data.shipping_type,
        Price: price,
        Category_Parent: extractProducts.categoriesParent,
        Category_Child: extractProducts.categoriesChild,
        Category_GrandChild: extractProducts.categoriesGrandChild,
        Content_Name: extractProducts.productsName,
        Contents: extractProducts.contents,
        Quantity: extractProducts.totalQuantity,
        Brand: extractProducts.brands,
      },
    };

    window.dataLayer.push(this.payload);
    FbConversion.fbTracking({
      name: 'InitiateCheckout',
      data: {
        content_ids: contentsId,
        currency: 'IDR',
        value: parseFloat(price),
        content_name: extractProducts.productsName.join(', '),
        contents: extractProducts.contents,
        content_type: 'product',
        content_category: extractProducts.categoriesParent.join(', '),
        content_subcategory1: extractProducts.categoriesChild.join(', '),
        content_subcategory2: extractProducts.categoriesGrandChild.join(', '),
        brand: extractProducts.brands.join(', '),
        quantity: extractProducts.totalQuantity,
      },
    });

    this.eventName = 'initiateCheckout';
    return this;
  },
  viewContent(product) {
    const combinationInfo = getCombinationInfo(product);
    let contentId = $get(
      product,
      'default_combination.tracker_combination_name',
      '',
    );

    if (!contentId) {
      const productId = product.id;
      const attributeSlug =
        formatAttributeSlug(combinationInfo.attributeSlug) || '';
      contentId = `${productId}_${attributeSlug}`;
    }

    this.payload = {
      event: 'viewContent',
      view_content_data: {
        Brand: $get(product, 'brand.name', ''),
        Category_Parent: $get(product, 'categories[0].name', ''),
        Category_Child: $get(product, 'categories[1].name', ''),
        Category_GrandChild: $get(product, 'categories[2].name', ''),
        Category: $get(product, 'default_category.name', ''),
        Id: product.id,
        Product_Name: product.name,
        Price: $get(product, 'default_combination.price_after_discount', ''),
        Combination_Name: combinationInfo.combinationName,
        Attribute_Slug: combinationInfo.attributeSlug,
        SKU: getSKU(product),
        Contents_Ids: contentId.toLowerCase(),
        Quantity: 1,
        Contents: [
          {
            id: contentId.toLowerCase(),
            quantity: 1,
          },
        ],
      },
      ga4ViewContent: {
        items: [
          {
            item_id: product.id,
            item_name: product.name,
            item_brand: $get(product, 'brand.name', ''),
            item_category: $get(product, 'default_category.name', ''),
            item_category2: $get(product, 'categories[0].name', ''),
            item_category3: $get(product, 'categories[1].name', ''),
            item_category4: $get(product, 'categories[2].name', ''),
            item_variant: combinationInfo.combinationName,
            price: $get(
              product,
              'default_combination.price_after_discount',
              '',
            ),
          },
        ],
      },
    };

    window.dataLayer.push(this.payload);
    FbConversion.fbTracking({
      name: 'ViewContent',
      data: {
        content_ids: contentId.toLowerCase(),
        content_type: 'product',
        content_name: product.name,
        content_brand: $get(product, 'brand.name', ''),
        content_category: $get(product, 'default_category.name', ''),
        content_subcategory1: $get(product, 'categories[0].name', ''),
        content_subcategory2: $get(product, 'categories[1].name', ''),
        content_subcategory3: $get(product, 'categories[2].name', ''),
        value: $get(product, 'default_combination.price_after_discount', ''),
        currency: 'IDR',
        search_keyword: product.keyword,
        search_result: product.name,
        contents: [
          {
            id: contentId.toLowerCase(),
            quantity: 1,
          },
        ],
        // quantity: 1,
        // sku: getSKU(product),
      },
    });
    this.eventName = 'viewContent';
    return this;
  },
  trackProductInsider(product) {
    if (typeof window === 'undefined') return;

    const images = product.default_combination.images;
    const image = images?.length
      ? images.find((img) => img.is_cover) || images[0]
      : null;

    let productUrl = Config.LULLA_WEB_URL;
    if (product.default_category?.slug) {
      productUrl += `/${$get(product, 'default_category.slug')}`;
    }
    if (product.slug) {
      productUrl += `/${$get(product, 'slug')}`;
    }

    const product_data = {
      id: $get(product, 'id')?.toString(),
      name: $get(product, 'name'),
      taxonomy: ($get(product, 'categories') || []).map((c) => c.name),
      currency: 'IDR',
      unit_price: $get(product, 'default_combination.price'),
      unit_sale_price: $get(
        product,
        'default_combination.price_after_discount',
      ),
      url: productUrl,
      stock: $get(product, 'default_combination.stock'),
      size: $get(product, 'default_combination.attributes.size.name') || '-',
      product_image_url: image?.url || '',
      custom: {
        shade:
          $get(product, 'default_combination.attributes.shade.name') || '-',
        variant:
          $get(product, 'default_combination.attributes.variant.name') || '-',
        non_specify:
          $get(product, 'default_combination.attributes.non_specify.name') ||
          '-',
        combination_id: $get(product, 'default_combination._id'),
        brand_name: $get(product, 'brand.name'),
      },
    };

    window.insider_object = window.insider_object || {};
    window.insider_object.page = { type: 'Product' };
    window.insider_object.product = product_data;

    window.dataLayer.push({ event: 'productDetail', product_data });

    window.Insider?.eventManager?.dispatch(
      'init-manager:re-initialize',
      window.insider_object,
    );
  },
  viewBrands(brand) {
    window.dataLayer.push({
      event: 'brand_page',
      brand_page: brand.name,
    });
  },
  search(payload) {
    this.payload = {
      event: 'search',
      search_data: {
        search_keyword: payload.text,
        search_result: payload.SearchResult,
      },
    };

    window.dataLayer.push(this.payload);
    FbConversion.fbTracking({
      name: 'Search',
      data: {
        search_keyword: payload.text,
        search_result: payload.SearchResult,
      },
    });
    this.eventName = 'search';
    return this;
  },
  purchaseConfirmaton(data) {
    try {
      if (!data) return;

      const products = data?.products ?? data?.cartDetail?.products ?? [];
      const isCardPayment = ['credit_card', 'debit_card'].includes(
        data?.payment_type,
      );

      const transaction_obj = {
        order_id: data?._id || data?.id_order || data?.order_id || '',
        currency: 'IDR',
        total: data?.total_paid ?? data?.gross_amount ?? 0,
        shipping_cost:
          data?.total_shipping ?? data?.cartDetail?.total_shipping ?? 0,
        delivery: {
          country: 'ID',
          city:
            data?.shipping?.delivery_address?.city?.name ??
            data?.cartDetail?.address?.city?.name ??
            '',
          district:
            data?.shipping?.delivery_address?.district?.name ??
            data?.cartDetail?.address?.district?.name ??
            '',
        },
        payment_type: isCardPayment
          ? `${data?.payment_type} - ${data?.bank ?? ''} ${
              data?.card_type ?? ''
            }`
          : data?.payment_method?.name ??
            data?.activedPayment?.name ??
            data?.payment_type ??
            '',
        line_items: products.map((pr = {}) => {
          const categories = [];
          if (pr?.category_parent) {
            categories.push(pr.category_parent);
          } else if (pr?.categories && pr.categories.length > 0) {
            categories.push(pr.categories[0]?.name ?? '');
          }
          if (pr?.category_child) {
            categories.push(pr.category_child);
          } else if (pr?.categories && pr.categories.length > 1) {
            categories.push(pr.categories[1]?.name ?? '');
          }
          if (pr?.category_grandchild) {
            categories.push(pr.category_grandchild);
          } else if (pr?.categories && pr.categories.length > 2) {
            categories.push(pr.categories[2]?.name ?? '');
          }

          const combination = pr?.combination ?? pr?.detail?.combination ?? {};
          const combinationName = { attributes: {} };

          if (combination?.attributes?.size) {
            combinationName.attributes.size = combination.attributes.size;
          }
          if (combination?.attributes?.shade) {
            combinationName.attributes.shade = combination.attributes.shade;
          }
          if (combination?.attributes?.variant) {
            combinationName.attributes.variant = combination.attributes.variant;
          }
          if (combination?.attributes?.non_specify) {
            combinationName.attributes.non_specify =
              combination.attributes.non_specify;
          }

          const combinationNameStr = generateCombinationName(
            combinationName,
            true,
          );

          return {
            product: {
              id: `${pr?.id ?? ''}_${combinationNameStr}`,
              groupcode: (pr?.id ?? '').toString(),
              name: pr?.name ?? pr?.detail?.name ?? '',
              taxonomy: categories,
              currency: 'IDR',
              unit_price: pr?.unit_price ?? pr?.detail?.combination?.price ?? 0,
              unit_sale_price:
                pr?.unit_price_after_discount ??
                pr?.detail?.combination?.price_after_discount ??
                0,
              url: pr?.url ?? pr?.url_sociolla ?? '',
              size: combination?.attributes?.size?.name ?? '',
              product_image_url:
                pr?.images?.[0]?.url ?? pr?.detail?.image?.url ?? '',
              custom: {
                variant: combination?.attributes?.variant?.name ?? '',
                shade: combination?.attributes?.shade?.name ?? '',
                non_specify: combination?.attributes?.non_specify?.name ?? '',
                combination_id: combination?._id ?? combination?.id ?? '',
                brand_name: pr?.brand?.name ?? pr?.detail?.brand?.name ?? '',
                total_redeem_point:
                  data?.total_redeem_point ??
                  data?.cartDetail?.total_point ??
                  0,
                voucher_applied_code:
                  data?.voucher_applied?.code ??
                  data?.cartDetail?.discount?.applied_vouchers?.[0]?.code ??
                  '',
              },
            },
            quantity: pr?.quantity ?? 0,
            subtotal:
              pr?.price_after_discount ??
              pr?.detail?.combination?.price_after_discount ??
              0,
          };
        }),
      };

      if (typeof window !== 'undefined' && window.dataLayer) {
        window.insider_object = window.insider_object || {};
        delete window.insider_object.basket;
        window.insider_object.page = { type: 'Confirmation' };
        window.insider_object.transaction = transaction_obj;

        window.dataLayer.push({
          event: 'purchaseConfirmation',
          transaction_object: transaction_obj,
        });

        window.Insider?.eventManager?.dispatch(
          'init-manager:re-initialize',
          window.insider_object,
        );
      }
    } catch (error) {
      console.error('Error in purchaseConfirmation:', error);
    }
  },
  purchase(data) {
    try {
      let ga4ProductItems = [];

      if (!data?.cartDetail?.products?.length) {
        console.warn('No products data available for purchase tracking');
        return this;
      }

      const extractProducts = getListProductsInfo(data.cartDetail.products) || {
        contentsId: [],
        brands: [],
        totalQuantity: 0,
        productsName: [],
        productsId: [],
        combinationsName: [],
        contents: [],
        categoriesParent: [],
        categoriesChild: [],
        categoriesGrandChild: [],
      };

      const contentsId = Array.isArray(extractProducts.contentsId)
        ? extractProducts.contentsId.filter(Boolean).join(', ')
        : '';

      const isCardPayment = ['credit_card', 'debit_card'].includes(
        data?.payment_type,
      );

      ga4ProductItems = (
        data?.products ??
        data?.cartDetail?.products ??
        []
      ).map((res = {}) => ({
        item_id: res?.id ?? '',
        item_name: res?.name ?? '',
        affiliation: 'Lilla Online Beauty Store',
        item_brand: res?.brand?.name ?? '',
        item_category: res?.default_category?.name ?? '',
        quantity: res?.quantity ?? 0,
        price: res?.price_after_discount ?? 0,
      }));

      for (let i = 0; i < ga4ProductItems.length; i++) {
        ga4ProductItems[i].item_variant =
          extractProducts.combinationsName?.[i] ?? '';
        ga4ProductItems[i].item_category2 =
          extractProducts.categoriesParent?.[i] ?? '';
        ga4ProductItems[i].item_category3 =
          extractProducts.categoriesChild?.[i] ?? '';
        ga4ProductItems[i].item_category4 =
          extractProducts.categoriesGrandChild?.[i] ?? '';
      }

      if (typeof window !== 'undefined' && window.dataLayer) {
        const paymentMethod = isCardPayment
          ? `${data.payment_type} - ${data.bank ?? ''} ${data.card_type ?? ''}`
          : $get(data, 'payment_method.name', '');

        const totalValue = data?.total_paid ?? data?.gross_amount ?? 0;
        const orderId =
          $get(data, '_id', '') || data?.id_order || data?.order_id || '';
        const orderRef = $get(data, 'reference_code', '');

        const infoShipping =
          'total_shipping' in data ? Number(data.total_shipping) : 0;
        const voucherUsed =
          'voucher_applied' in data && data.voucher_applied?.code
            ? data.voucher_applied.code
            : '';

        window.dataLayer.push({
          event: 'purchase',
          value: totalValue,
          currency: 'IDR',
          transaction_id: orderId,
          shipping: infoShipping,
          tax: 0,
          coupon: voucherUsed,
          order_ref: orderRef,
          payment_method: paymentMethod,

          ecommerce: {
            currencyCode: 'IDR',
            purchase: {
              actionField: {
                id: orderId,
                affiliation: 'Lilla Online Beauty Store',
                revenue: totalValue,
                tax: 0,
                shipping: infoShipping,
                coupon: voucherUsed,
              },
            },
          },

          purchase_data: {
            Brand: extractProducts.brands ?? [],
            Quantity: extractProducts.totalQuantity ?? 0,
            Product_Name: extractProducts.productsName ?? [],
            Product_Id: extractProducts.productsId ?? [],
            Payment_Method: paymentMethod,
            Amount_Of_Purchase: totalValue,
            Order_Id: orderId,
            Combination_Name: extractProducts.combinationsName ?? [],
            Content_Ids: extractProducts.contentsId ?? [],
            Contents: extractProducts.contents ?? [],
            Category_Parent: extractProducts.categoriesParent ?? [],
            Category_Child: extractProducts.categoriesChild ?? [],
            Category_GrandChild: extractProducts.categoriesGrandChild ?? [],
            currency: 'IDR',
            value: totalValue,
            transaction_id: orderId,
            payment_method: paymentMethod,
            order_ref: orderRef,
            shipping: infoShipping,
            tax: 0,
            coupon: voucherUsed,
          },
          ga4Purchase: {
            affiliation: 'Lilla Online Beauty Store',
            items: ga4ProductItems,
          },
        });

        FbConversion.fbTracking({
          name: 'Purchase',
          data: {
            value: totalValue,
            order_id: orderId,
            currency: 'IDR',
            brand: Array.isArray(extractProducts.brands)
              ? extractProducts.brands.join(', ')
              : '',
            contents: extractProducts.contents ?? [],
            content_ids: contentsId,
            content_type: 'product',
            content_name: Array.isArray(extractProducts.productsName)
              ? extractProducts.productsName.join(', ')
              : '',
            content_brand: Array.isArray(extractProducts.brands)
              ? extractProducts.brands.join(', ')
              : '',
            content_product_id: Array.isArray(extractProducts.productsId)
              ? extractProducts.productsId.join(', ')
              : '',
            content_category: Array.isArray(extractProducts.categoriesParent)
              ? extractProducts.categoriesParent.join(', ')
              : '',
            content_subcategory1: Array.isArray(extractProducts.categoriesChild)
              ? extractProducts.categoriesChild.join(', ')
              : '',
            payment_method: paymentMethod,
          },
        });
      }
    } catch (error) {
      console.error('Error in purchase tracking:', error);
    }

    this.eventName = 'purchase';
    return this;
  },

  userTrack(user) {
    if (user) {
      window.dataLayer.push({
        event: 'userTrack',
        user_id_mongo: user._id,
        user_data: {
          userIDMongo: user._id,
          userEmail: user.email,
          userName: user.user_name,
          userFirstname: user.first_name,
          userLastname: user.last_name,
          userBirth: user.date_of_birth,
          userGender: user.gender,
          userPhone: user.phone_no_e164,
          socoPoints: user.lilla_points?.count || '',
          userLevel: user.lilla_level?.current?.stage || '',
          isVerifiedEmail: user.is_verified_email || false,
          isVerifiedPhone: user.is_verified_phone || false,
          beautyCreatedAt: user.beauty_created_at ? true : false,
          country: user.country?.name || '',
          district: user.district?.name || '',
          city: user.city?.name || '',
          province: user.province?.name || '',
        },
      });
    }
  },
  pageTracking(name) {
    window.dataLayer.push({
      event: 'pageNameReady',
      page_name: name,
    });
  },
  bannerClick: () => {},
  trackCartInsider(cart) {
    const products = cart.products || cart.items || [];
    const cart_data = {
      currency: 'IDR',
      total: cart.total_amount_after_discount || cart.total || 0,
      line_items: products.map((product) => {
        const detail = product.detail || product;
        const combination = detail.combination || product.combination || {};
        let productUrl = Config.LULLA_WEB_URL;
        if (product.default_category?.slug) {
          productUrl += `/${$get(product, 'default_category.slug')}`;
        }
        if (product.slug) {
          productUrl += `/${$get(product, 'slug')}`;
        }
        return {
          product: {
            id:
              $get(product, 'id')?.toString() ||
              $get(product, '_id')?.toString(),
            name: $get(detail, 'name'),
            taxonomy: [
              ...($get(product, 'categories') || []).map(
                (category) => category.name,
              ),
            ],
            currency: 'IDR',
            unit_price: $get(combination, 'price'),
            unit_sale_price: $get(combination, 'price_after_discount'),
            url: productUrl,
            stock: $get(combination, 'stock') ?? $get(product, 'stock'),
            size: $get(combination, 'attributes.size.name') || '-',
            product_image_url:
              $get(detail, 'image.url') || $get(product, 'images[0].url', ''),
            custom: {
              shade: $get(combination, 'attributes.shade.name') || '-',
              variant: $get(combination, 'attributes.variant.name') || '-',
              non_specify:
                $get(combination, 'attributes.non_specify.name') || '-',
              combination_id:
                $get(product, 'combination_id') || $get(combination, '_id'),
              brand_name:
                $get(detail, 'brand.name') || $get(product, 'brand.name'),
            },
          },
          quantity: product.quantity,
          subtotal:
            $get(combination, 'total_price') ||
            ($get(combination, 'price_after_discount') || 0) *
              (product.quantity || 1),
        };
      }),
    };

    if (typeof window !== 'undefined') {
      window.insider_object = window.insider_object || {};
      window.insider_object.basket =
        cart_data.line_items?.length > 0 ? cart_data : undefined;

      window.dataLayer.push({ event: 'cartChange', cart_data });

      window.Insider?.eventManager?.dispatch(
        'init-manager:re-initialize',
        window.insider_object,
      );
    }
  },
  trackCartInsiderAddToCart(product, combination, quantity) {
    try {
      const selectedCombination =
        combination || product.default_combination || {};
      let image;
      if (selectedCombination.images?.length) {
        image = selectedCombination.images.find((img) => img.is_cover);
        if (!image) {
          image = selectedCombination.images[0];
        }
      }
      let productUrl = Config.LULLA_WEB_URL;
      if (product.default_category?.slug) {
        productUrl += `/${$get(product, 'default_category.slug')}`;
      }
      if (product.slug) {
        productUrl += `/${$get(product, 'slug')}`;
      }

      const product_data = {
        id: $get(product, 'id')?.toString(),
        name: $get(product, 'name'),
        taxonomy: [
          ...($get(product, 'categories') || []).map(
            (category) => category.name,
          ),
        ],
        currency: 'IDR',
        unit_price: $get(selectedCombination, 'price'),
        unit_sale_price: $get(selectedCombination, 'price_after_discount'),
        url: productUrl,
        stock: $get(selectedCombination, 'stock'),
        size: $get(selectedCombination, 'attributes.size.name') || '-',
        product_image_url: image?.url || '',
        custom: {
          shade: $get(selectedCombination, 'attributes.shade.name') || '-',
          variant: $get(selectedCombination, 'attributes.variant.name') || '-',
          non_specify:
            $get(selectedCombination, 'attributes.non_specify.name') || '-',
          combination_id: $get(selectedCombination, '_id'),
          brand_name: $get(product, 'brand.name'),
        },
      };

      if (typeof window !== 'undefined') {
        window.insider_object = window.insider_object || {};
        const unit_price =
          $get(selectedCombination, 'price_after_discount') || 0;
        const qty = quantity || 1;
        const lineItem = {
          product: product_data,
          quantity: qty,
          subtotal: unit_price * qty,
        };

        if (!window.insider_object.basket) {
          window.insider_object.basket = {
            currency: 'IDR',
            total: lineItem.subtotal,
            line_items: [lineItem],
          };
        } else {
          const currentItems = window.insider_object.basket.line_items || [];
          const existingIndex = currentItems.findIndex(
            (item) =>
              item.product?.id === lineItem.product.id &&
              (item.product?.custom?.combination_id || '') ===
                (lineItem.product.custom?.combination_id || ''),
          );
          const addedSubtotal = unit_price * qty;

          if (existingIndex !== -1) {
            const existing = currentItems[existingIndex];
            window.insider_object.basket.line_items = [
              ...currentItems.slice(0, existingIndex),
              {
                ...existing,
                quantity: (existing.quantity || 1) + qty,
                subtotal: (existing.subtotal || 0) + addedSubtotal,
              },
              ...currentItems.slice(existingIndex + 1),
            ];
          } else {
            window.insider_object.basket.line_items = [
              ...currentItems,
              lineItem,
            ];
          }

          window.insider_object.basket.total =
            (window.insider_object.basket.total || 0) + addedSubtotal;
        }

        window.dataLayer.push({
          event: 'itemAddedToCart',
          product_data,
          quantity: qty,
        });

        window.Insider?.eventManager?.dispatch(
          'init-manager:re-initialize',
          window.insider_object,
        );
      }
    } catch (error) {
      console.error('Error in trackCartInsiderAddToCart:', error);
    }
  },
  buyNowClicked(product, params = {}) {
    const { combinationId, quantity, voucherCode, voucherId, reference } =
      params;
    let productUrl = Config.LULLA_WEB_URL;
    if (product?.default_category?.slug) {
      productUrl += `/${$get(product, 'default_category.slug')}`;
    }
    if (product?.slug) {
      productUrl += `/${$get(product, 'slug')}`;
    }
    this.payload = {
      event: 'buy_now_clicked',
      product_id: product?.id || '',
      product_name: product?.name || '',
      combination_id: combinationId || '',
      reference: reference || '',
      product_classification: product?.classification || '',
      brand_id: $get(product, 'brand.id', ''),
      brand_name: $get(product, 'brand.name', ''),
      default_category: $get(product, 'default_category.name', ''),
      voucher_code: voucherCode || '',
      voucher_id: voucherId || '',
      quantity: parseInt(quantity) || 0,
      product_url: productUrl,
    };
    window.dataLayer.push(this.payload);
    this.eventName = 'buy_now_clicked';
    return this;
  },
  proceedToCheckoutBuyNow(product, params = {}) {
    const { combinationId, quantity, voucherCode, voucherId, reference } =
      params;
    let productUrl = Config.LULLA_WEB_URL;
    if (product?.default_category?.slug) {
      productUrl += `/${$get(product, 'default_category.slug')}`;
    }
    if (product?.slug) {
      productUrl += `/${$get(product, 'slug')}`;
    }
    this.payload = {
      event: 'proceed_to_checkout_clicked',
      product_id: product?.id || '',
      product_name: product?.name || '',
      combination_id: combinationId || '',
      reference: reference || '',
      product_classification: product?.classification || '',
      brand_id: $get(product, 'brand.id', ''),
      brand_name: $get(product, 'brand.name', ''),
      default_category: $get(product, 'default_category.name', ''),
      voucher_code: voucherCode || '',
      voucher_id: voucherId || '',
      quantity: parseInt(quantity) || 0,
      product_url: productUrl,
    };
    window.dataLayer.push(this.payload);
    this.eventName = 'proceed_to_checkout_clicked';
    return this;
  },
  proceedToPaymentClicked(params = {}) {
    const { deliveryOptions, paymentMethod, productUrl } = params;
    this.payload = {
      event: 'proceed_to_payment_clicked',
      delivery_options: deliveryOptions || '',
      payment_method: paymentMethod || '',
      product_url: productUrl || '',
    };
    window.dataLayer.push(this.payload);
    this.eventName = 'proceed_to_payment_clicked';
    return this;
  },
  cancelOrderButtonClicked(params = {}) {
    this.payload = {
      event: 'cancel_order_button_clicked',
      order_id: params.orderId || '',
    };
    window.dataLayer.push(this.payload);
    this.eventName = 'cancel_order_button_clicked';
    return this;
  },
  proceedToCancelClicked(params = {}) {
    this.payload = {
      event: 'proceed_to_cancel_clicked',
      order_id: params.orderId || '',
      cancellation_reason: params.cancellationReason || '',
    };
    window.dataLayer.push(this.payload);
    this.eventName = 'proceed_to_cancel_clicked';
    return this;
  },
  cancelledOrder(params = {}) {
    this.payload = {
      event: 'cancelled_order',
      order_id: params.orderId || '',
      cancellation_reason: params.cancellationReason || '',
    };
    window.dataLayer.push(this.payload);
    this.eventName = 'cancelled_order';
    return this;
  },
  debug() {
    if (ENV.debug) {
      if (this.payload && Object.keys(this.payload).length) {
        console.log(`-----Event ${this.eventName} Data-----`);
        for (const key in this.payload) {
          console.log(`${key} => ${this.payload[key]}`);
          if (typeof this.payload[key] === 'object') {
            for (const keyChild in this.payload[key]) {
              console.log(`${keyChild} => ${this.payload[key][keyChild]}`);
            }
          }
        }
        console.log('-----EndDebug-----');
      }
    }
    return this;
  },
};

export default GoogleTagManager;
